export default __webpack_public_path__ + "static/media/img-slider-tspace-3.c683abf2.png";